export default __webpack_public_path__ + "static/media/AboutImage.9dccddd7.png";